var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('v-container',{staticStyle:{"max-width":"1024px"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Map')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }